import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import { toast } from "sonner";
import {
  callToast,
  showErrorMessages,
} from "../../../src/services/utilityFunctions.js";
import { useGlobalState } from "../../../src/services/hostelConst";
import { getLocalStorageData } from "../../services/axiosComponent";
import { selectStyle } from "../../services/constant";
import {
  getTutorList,
  getSubjectList,
  createDivisionSectionSubject,
  updateDivisionSectionSubject,
  getDivisionSectionSubjectDetails,
} from "../../services/Academic-Services.js";
import { closeModal } from "../../services/redux/reducers/modalSlice";
import { useDispatch, useSelector } from "react-redux";
import AddDivisionSectionForm from "./AddDivisionSection.js";

const AddDivisionSectionSubjectForm = ({ navigate, refresh, params }) => {
  const modal = useSelector((state) => state.modal);
  const sectionDetails = useSelector((state) => state.section);
  console.log("Section Details", sectionDetails);
  const dispatch = useDispatch();

  // States for loading indicators
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(modal.isEditing);
  const [isTutorOptionsLoading, setIsTutorOptionsLoading] = useState(false);
  const [isSubjectOptionsLoading, setIsSubjectOptionsLoading] = useState(false);

  // Options for select fields
  const [tutorOptions, setTutorOptions] = useState([]);
  const [subjectOptions, setSubjectOptions] = useState([]);

  // Form validation
  const [errors, setErrors] = useState({});

  // Initial form data setup
  const prepareFormData = (data = null) => {
    return {
      name: data != null ? data.NAME : "",
      description: data != null ? data.DESCRIPTION : "",
      tutor: {
        value: data != null ? data._TUTOR : "",
        label: data != null ? data.TUTOR : "",
      },
      subject: {
        value: data != null ? data._SUBJECT : "",
        label: data != null ? data.SUBJECT : "",
      },
    };
  };

  const [formData, setFormData] = useState(prepareFormData());

  // Fetch existing entity data if editing
  const getEntityDetails = async (entityId) => {
    setLoadingData(true);

    // Replace with your actual entity details API call
    var res = await getDivisionSectionSubjectDetails(entityId);
    if (res.status == "success") {
      console.log(res, "get entity details");
      setFormData(prepareFormData(res.data));
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setLoadingData(false);
  };

  // Handle form field changes
  const handleChange = (field, value) => {
    setErrors({});
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  // Form validation
  const validateFields = () => {
    let isValid = true;
    let errors = {};

    if (formData.name === "") {
      isValid = false;
      errors.name = "Name is required";
    }

    if (formData.description === "") {
      isValid = false;
      errors.description = "Description is required";
    }

    if (formData.tutor.value === "") {
      isValid = false;
      errors.tutor = "Tutor is required";
    }

    if (formData.subject.value === "") {
      isValid = false;
      errors.subject = "Subject is required";
    }

    setErrors(errors);
    return isValid;
  };

  // Form submission
  const handleSubmit = async () => {
    if (validateFields()) {
      setLoading(true);

      // Prepare submission data
      const submitData = {
        name: formData.name,
        description: formData.description,
        tutorId: formData.tutor.value,
        subjectId: formData.subject.value,
        regionId: sectionDetails._REGION,
        siteId: sectionDetails._SITE,
        sectionId: sectionDetails._ID,
        organizationId:
          getLocalStorageData("profileDetails")?.["_ORGANIZATION_"]?._ID,
        id: modal.isEditing ? modal.data._ID : null,
      };
      console.log(submitData, "submitData");

      // Replace with your actual API calls
      var res = !modal.isEditing
        ? await createDivisionSectionSubject(submitData)
        : await updateDivisionSectionSubject(submitData);
      if (res.status == "success") {
        callToast(
          "success",
          modal.isEditing ? "Updated" : "Created",
          `Entity ${modal.isEditing ? "updated" : "created"} successfully`
        );

        await refresh({ columnRefresh: false, isLoading: false });

        dispatch(closeModal());
      } else {
        showErrorMessages({ data: res, navigate });
      }
      setLoading(false);
    }
  };

  // Fetch tutors
  const getTutorListOptions = async (query = "") => {
    setIsTutorOptionsLoading(true);
    var res = await getTutorList({
      query: query,
      status: "Y",
      regionId: sectionDetails._REGION,
      siteId: sectionDetails._SITE,
      sectionId: sectionDetails._ID,
    });
    if (res.status == "success") {
      var list = [];
      res.data.entityList.map((item) => {
        list.push({ value: item._ID, label: item.NAME });
      });
      setTutorOptions(list);
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setIsTutorOptionsLoading(false);
  };

  // Fetch subjects
  const getSubjectListOptions = async (query = "") => {
    setIsSubjectOptionsLoading(true);
    var res = await getSubjectList({
      query: query,
      status: "Y",
      regionId: sectionDetails._REGION,
      siteId: sectionDetails._SITE,

    });
    if (res.status == "success") {
      var list = [];
      res.data.entityList.map((item) => {
        list.push({ value: item._ID, label: item.NAME });
      });
      setSubjectOptions(list);
    } else {
      showErrorMessages({ data: res, navigate });
    }
    setIsSubjectOptionsLoading(false);
  };

  useEffect(() => {
    // Initial data loading
    getTutorListOptions();
    getSubjectListOptions();

    if (modal.isEditing) {
      getEntityDetails(modal.data._ID);
    }

    return () => {};
  }, []);

  return (
    <>
      {loadingData ? (
        <center>
          <div className="spinner-border text-primary" role="status">
            <span className="sr-only">Loading...</span>
          </div>
        </center>
      ) : (
        <section className="login-content">
          <div className="">
            <div className="d-flex">
              <div className="w-100 ps-4 pe-4">
                <form>
                  <div className="mb-3">
                    <div className="form-row">
                      <div className="col">
                        <label className="form-label">Name</label>
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Enter name"
                          value={formData.name}
                          onChange={(e) => handleChange("name", e.target.value)}
                        />
                        {errors.name && (
                          <small className="text-danger">{errors.name}</small>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <div className="form-row">
                      <div className="col">
                        <label className="form-label">Description</label>
                        <input
                          className="form-control"
                          placeholder="Enter description"
                          value={formData.description}
                          onChange={(e) =>
                            handleChange("description", e.target.value)
                          }
                        />
                        {errors.description && (
                          <small className="text-danger">
                            {errors.description}
                          </small>
                        )}
                      </div>
                    </div>
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Tutor</label>
                    <Select
                      styles={selectStyle}
                      options={tutorOptions}
                      value={
                        formData.tutor.label === "" ? null : formData.tutor
                      }
                      components={
                        isTutorOptionsLoading ? { DropdownIndicator } : null
                      }
                      onChange={(newValue) => {
                        handleChange(
                          "tutor",
                          newValue == null ? { value: "", label: "" } : newValue
                        );
                      }}
                      onInputChange={(inputValue, { action }) => {
                        if (action === "input-change") {
                          getTutorListOptions(inputValue);
                        }
                      }}
                      noOptionsMessage={() => "No tutors available"}
                      isSearchable={true}
                      placeholder="Select Tutor"
                      className="basic-single"
                      classNamePrefix="select"
                    />
                    {errors.tutor && (
                      <small className="text-danger">{errors.tutor}</small>
                    )}
                  </div>

                  <div className="mb-3">
                    <label className="form-label">Subject</label>
                    <Select
                      styles={selectStyle}
                      options={subjectOptions}
                      value={
                        formData.subject.label === "" ? null : formData.subject
                      }
                      components={
                        isSubjectOptionsLoading ? { DropdownIndicator } : null
                      }
                      onChange={(newValue) => {
                        handleChange(
                          "subject",
                          newValue == null ? { value: "", label: "" } : newValue
                        );
                      }}
                      onInputChange={(inputValue, { action }) => {
                        if (action === "input-change") {
                          getSubjectListOptions(inputValue);
                        }
                      }}
                      noOptionsMessage={() => "No subjects available"}
                      isSearchable={true}
                      placeholder="Select Subject"
                      className="basic-single"
                      classNamePrefix="select"
                    />
                    {errors.subject && (
                      <small className="text-danger">{errors.subject}</small>
                    )}
                  </div>

                  <div className="d-flex justify-content-end mt-4 gap-2">
                    <button
                      type="button"
                      className="btn btn-light me-2"
                      onClick={() => dispatch(closeModal())}
                    >
                      Cancel
                    </button>
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={handleSubmit}
                      disabled={loading}
                    >
                      {loading ? (
                        <div
                          className="spinner-border text-light spinner-border-sm"
                          role="status"
                        >
                          <span className="sr-only">Loading...</span>
                        </div>
                      ) : modal.isEditing ? (
                        "Update"
                      ) : (
                        "Submit"
                      )}
                    </button>
                  </div>
                </form>
              </div>
            </div>
          </div>
        </section>
      )}
    </>
  );
};

// Loading indicator for Select components
const DropdownIndicator = (props) => {
  return (
    <div {...props.innerProps}>
      <div
        className="spinner-border text-primary spinner-border-sm m-2"
        role="status"
      >
        <span className="sr-only">Loading...</span>
      </div>
    </div>
  );
};

export default AddDivisionSectionSubjectForm;
